export enum CompleteInspectionType {
    Representative = 'R',
    Officer = 'O',
  }